import { GameStyle } from "@lib/js-slingo-pawnshop-core/dist";
import { AbstractNavigationProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractNavigationProperties";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import * as PIXI from "pixi.js";
/**
 * NavigationLandscapeProperties.ts
 */
export class NavigationLandscapeProperties extends AbstractNavigationProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties = new SpriteProperties(GameStyle.NAVIGATION_BACKGROUND, SlingoStyle.MODULE);
        this.backgroundProperties.position = new PIXI.Point(973, 0);
        this.backgroundProperties.visible = false;
        this.backgroundProperties.anchor.set(0.5, 0);
        this.balanceFieldProperties.size = new PIXI.Point(500, 57);
        this.stakeProperties.size = new PIXI.Point(500, 57);
        this.totalStakeProperties.size = new PIXI.Point(500, 57);
        this.balanceFieldProperties.position.set(0, -5);
        this.stakeProperties.position.set(0, -5);
        this.totalStakeProperties.position.set(0, -5);
        this.fieldOffset = 40;
    }
}
